import React, { useCallback, useEffect, useState } from "react";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { FiPlusCircle } from "react-icons/fi";
import { Link } from "react-router-dom";

import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { formAFilterFields, formAManagementColumns } from "./FormAManagement.data";
import { getAllFormA } from "app/_services/UserManagement/FormAService";
import { useForm } from "app/_helpers/hooks";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import FormAFilters from "./FormAFilters";
import { ACTIVE_MODULE, filterActionAdd } from "app/_constants/constant";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import FormCheckbox from "app/Components/_form/FormCheckbox/FormCheckbox";

const initialFilter = { staffType: "all" };

const STAFF_TYPE = {
  employee: "Employee",
  contractor: "Contractor Person",
};

export default function FormAManagement() {
  const [filter, onChangeFilter] = useForm({ ...initialFilter });
  const [state, setState] = useState({
    rows: [],
    rowsFiltered: [],
  });
  const [formAList, setFormAList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [tab, setTab] = useState(1);
  const [filterForm, setFilterForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const onReset = () =>
    setFilterForm({ uanNo: "", panNo: "", aadharNumber: "", dob: "" });

  const onChange = ({ target: { name, value } }) => {
    setFilterForm((prev) => {
      if (name === "staffTypeName") {
        prev.id = "";
      }
      return { ...prev, [name]: value };
    });
  };

  const tableToolbarView = useCallback(() => {
    return (
      <>
        {/* <CustomTooltip tooltip="Add Employeees">
          <Link
            className="icons btn-icon font-20 text-cyanBlue"
            to="/user-management/employee/add"
          >
            <FiPlusCircle />
          </Link>
        </CustomTooltip> */}
      </>
    );
  }, []);

  useEffect(() => {
    // getAllFormA({}).then((response) => {
    //   if (!response?.data) return;
    //   setState((prevState) => ({
    //     ...prevState,
    //     rows: response.data.list.map((row) => ({
    //       ...row,
    //       staffType: "employeeFormA" in row ? "employee" : "contractor",
    //       staffTypeName: "employeeFormA" in row ? "Employee" : "Contractor Person",
    //       fullName: `${row.firstName || ""} ${row.lastName || ""}`,
    //       employeeId: row.employeeId || row.aadharNumber,
    //       formAStatus: row.employeeFormA || row.contractorFormA ? "Completed" : "Pending",
    //       siteName: row?.ehsSite?.name,
    //       uanNo:
    //         "employeeFormA" in row
    //           ? row?.employeeFormA?.uan?.toString()
    //           : row?.contractorFormA?.uan?.toString(),
    //       panNo:
    //         "employeeFormA" in row
    //           ? row?.employeeFormA?.panCard
    //           : row?.contractorFormA?.panCard,
    //       contractorId: +row?.contractorId,
    //     })),
    //   }));
    // });

    const fetchData = async () => {
      try {
        const response = await getAllFormA({});
        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }
        setState((prevState) => ({
          ...prevState,
          rows: response.data.list.map((row) => ({
            ...row,
            staffType: "employeeFormA" in row ? "employee" : "contractor",
            staffTypeName: "employeeFormA" in row ? "Employee" : "Contractor Person",
            fullName: `${row.firstName || ""} ${row.lastName || ""}`,
            employeeId: row.employeeId || row.aadharNumber,
            formA: row?.employeeFormA?.serialNumberOmc
              ? row?.employeeFormA?.serialNumberOmc
              : row?.srNo,
            formAStatus:
              row?.employeeFormA || row?.contractorFormA ? "Completed" : "Pending",
            siteName: row?.ehsSite?.name,
            uanNo:
              "employeeFormA" in row
                ? row?.employeeFormA?.uan?.toString()
                : row?.contractorFormA?.uan?.toString(),
            panNo:
              "employeeFormA" in row
                ? row?.employeeFormA?.panCard
                : row?.contractorFormA?.panCard,
            contractorId: +row?.contractorId,
          })),
        }));
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    setState((prevState) => {
      const rowsFiltered =
        tab === 1
          ? state.rows
          : state.rows.filter((row) =>
              tab === 2 ? row.formAStatus === "Completed" : row.formAStatus === "Pending"
            );

      const finalRowFilter = rowsFiltered.filter((data) => {
        for (const key in filterForm) {
          const value = filterForm[key];

          // Skip if the filter is empty or "All" for staffTypeName
          if (!value || (key === "staffTypeName" && value === "All")) continue;

          if (["uanNo", "panNo", "aadharNumber"].includes(key)) {
            if (
              !data[key]
                ?.toString()
                .toLowerCase()
                .includes(value.toString().toLowerCase())
            ) {
              return false;
            }
          } else {
            if (data[key] !== value) {
              return false;
            }
          }
        }
        return true;
      });

      return {
        ...prevState,
        rowsFiltered: finalRowFilter,
      };
    });
  }, [filterForm, state.rows, tab]);

  useEffect(() => {
    setFormAList(() => {
      const finalRowFilter = state?.rowsFiltered?.filter(
        (d) => (isActive && d?.employmentStatus === "active") || !isActive
      );
      return finalRowFilter;
    });
  }, [isActive, state?.rowsFiltered]);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <FormAFilters
        fields={formAFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChange}
        onReset={onReset}
      />
    );

  const onClickTab = (n) => {
    if (tab === n) return;
    setFormAList([]);
    setState((prev) => ({ ...prev, rowsFiltered: [] }));
    setTab(n);
  };

  const onChangeActive = () => {
    setFormAList([]);
    setIsActive(!isActive);
  };

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Form A Management",
          },
        ]}
        module={ACTIVE_MODULE.formA}
      />
      <br />
      <br />
      <div className="healthSafetyEnvironmentWrapper EHS_module_tabber">
        <div className="hseMenuLinks card">
          <a
            href
            onClick={() => onClickTab(1)}
            className={`pointer${tab === 1 ? " active" : ""}`}
          >
            ALL Form A
          </a>
          <a
            href
            onClick={() => onClickTab(2)}
            className={`pointer${tab === 2 ? " active" : ""}`}
          >
            Completed Form A
          </a>
          <a
            href
            onClick={() => onClickTab(3)}
            // style={{pointerEvents: 'none'}}
            className={`pointer${tab === 3 ? " active" : ""}`}
          >
            Pending Form A
          </a>
        </div>
      </div>
      <div className="py-3">
        <div className="card p-3 pb-0 mt-2 EHS_module_create_form">
          <div className="simple-card-title d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center justify-content-between">
              <h3 className="text-capitalize mb-0">{`${
                tab === 1 ? "ALL" : tab === 2 ? "Completed" : "Pending"
              } Form A`}</h3>
              <FilterBtn setShowFilter={setShowFilter} />
            </div>
            <div className="extraEle">
              <FormCheckbox
                type="checkbox"
                name="isActive"
                checked={isActive}
                onChange={() => onChangeActive()}
                label={"Active Employee / Contractor Staff"}
              />
            </div>
          </div>

          <div className="card-body">
            {!loading ? (
              <SearchBootstrapTable
                searchKey={"formADesktopSearch"}
                tableToolbarView={tableToolbarView}
                columns={formAManagementColumns}
                // data={state.rowsFiltered}
                data={formAList.map((d, idx) => ({ ...d, sid: idx + 1 }))}
                tableName="Form A"
                tableBeforeSearch={tableToolbarBeforeView}
                tableKey="formA"
              />
            ) : (
              <NetZeroLoader />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
